var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('div',{staticClass:"modal-overlay",on:{"click":_vm.hideModal}},[_c('div',{staticClass:"modal-content",on:{"click":function($event){$event.stopPropagation();}}},[_c('img',{attrs:{"src":_vm.imageUrl,"alt":"Image Preview"}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }